import configuracaoTelaApi from './configuracao-tela-api'

// Recurso "dashboard_analitico" (Recurso.GetDefaultRecursos no back).
// O pop-up inicial pertence a tela inicial, por isso as preferencias dele
// ficam no JSON desse recurso, gravado por usuario em ConfiguracaoTelaUsuario.
const RECURSO_DASHBOARD_ANALITICO = 7

const api = configuracaoTelaApi(RECURSO_DASHBOARD_ANALITICO)

async function lerConfiguracao() {
  const payload = await api.obter()
  if (!payload.data) return {}

  const configuracao = typeof payload.data === 'string' ? JSON.parse(payload.data) : payload.data

  return configuracao || {}
}

/**
 * Le as preferencias do pop-up inicial do usuario logado.
 * Nunca lanca: qualquer falha (rede, 500, JSON invalido) vira objeto vazio,
 * para nao travar o fluxo de login.
 */
export async function obterPreferencias() {
  try {
    return await lerConfiguracao()
  } catch (e) {
    return {}
  }
}

/**
 * Grava uma preferencia do pop-up inicial preservando as demais chaves,
 * porque o PUT sobrescreve o registro inteiro.
 *
 * Se as preferencias atuais nao forem informadas, releem do backend; falha
 * nessa leitura aborta a gravacao em vez de sobrescrever o que nao foi lido.
 * Nunca lanca: se falhar, o pop-up apenas volta a aparecer no proximo login.
 *
 * @param {string} chave
 * @param {*} valor
 * @param {object} [preferenciasAtuais] preferencias ja lidas pelo chamador
 */
export async function salvarPreferencia(chave, valor, preferenciasAtuais) {
  try {
    const preferencias = preferenciasAtuais || await lerConfiguracao()
    await api.salvar(JSON.stringify({ ...preferencias, [chave]: valor }))

    return true
  } catch (e) {
    return false
  }
}
